import "./LasVegasRefrigeratedTrailerRental.module.css";
import Header from "@/reusable_sections/Header";
import LasVegasHero from "./sections/LasVegasHero";
import TrailerLineup from "./sections/TrailerLineup";
import PotentialApplications from "./sections/PotentialApplications";
import NevadaAccess from "./sections/NevadaAccess";
import ServiceAreaMap from "./sections/ServiceAreaMap";
import LasVegasFaq from "./sections/LasVegasFaq";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function LasVegasRefrigeratedTrailerRentalPage() {
  return <div>
      <Header />
      <LasVegasHero />
      <TrailerLineup />
      <PotentialApplications />
      <NevadaAccess />
      <ServiceAreaMap />
      <LasVegasFaq />
      <QuoteCta />
      <Footer />
    </div>;
}